class GwpProductCard extends HTMLElement {
  connectedCallback() {
    this._handleClick = this.handleClick.bind(this);
    this.querySelector('.gwp-product-card__add-to-cart-button')
      ?.addEventListener('click', this._handleClick);
  }

  disconnectedCallback() {
    this.querySelector('.gwp-product-card__add-to-cart-button')
      ?.removeEventListener('click', this._handleClick);
  }

  async handleClick() {
    const button = this.querySelector('.gwp-product-card__add-to-cart-button');
    const miniCart = document.querySelector('mini-cart');
    const sections = miniCart ? miniCart.getSectionsToRender().map((s) => s.id) : [];

    const variantId = (
      this.querySelector('select[name="id"]') ||
      this.querySelector('input[name="id"]')
    )?.value;

    const gwpId = this.querySelector('input[name="properties[_bl_gwp]"]')?.value;

    if (!variantId) return;

    try {
      if (button) {
        button.setAttribute('aria-disabled', 'true');
        button.disabled = true;
      }

      const body = JSON.stringify({
        id: variantId,
        quantity: 1,
        properties: { _bl_gwp: gwpId },
        sections: sections,
        sections_url: window.location.pathname,
      });

      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/javascript',
        },
        body,
      });

      if (!response.ok) {
        throw new Error('Failed to add to cart');
      }

      const parsedState = await response.json();
      if (miniCart) miniCart.renderContents(parsedState);
    } catch (error) {
      console.error('error', error);
    } finally {
      if (button) {
        button.setAttribute('aria-disabled', 'false');
        button.disabled = false;
      }
    }
  }
}

if (!customElements.get('gwp-product-card')) {
  customElements.define('gwp-product-card', GwpProductCard);
}
